module.exports = __webpack_public_path__ + "img/multi_image08.5bb37b17.png";